import styled from 'styled-components'
import fonts from '../../tokens/fonts'
import colors from '../../tokens/colors'
import { composeTheme } from '../../utils/compose-theme'

export const Accordion = styled.div.attrs((props) => composeTheme(props))`
  background-color: ${(props) => props.theme.collapseCard.backgroundColor};
  position: relative;
  font-family: ${fonts.inter};
  max-width: 115.6rem;
  overflow: hidden;
`

export const AccordionItem = styled.div.attrs((props) => composeTheme(props))`
  border: ${(props) => props.theme.collapseCard.border};
  font-family: ${fonts.inter};
  border-radius: ${(props) => props.theme.collapseCard.borderRadius};
  box-sizing: border-box;
  padding: 2.4rem 2.4rem 2.4rem 2.4rem;
`

export const AccordionIcon = styled.div`
  margin-left: auto;
  transition: max-height 1s ease-in-out;
`

export const Title = styled.p.attrs((props) => composeTheme(props))`
  display: flex;
  font-family: ${fonts.inter};
  color: ${(props) => props.theme.collapseCard.titleColor};
  font-weight: ${(props) => props.theme.collapseCard.fontWeightTitle};
  font-size: ${(props) => props.theme.collapseCard.fontSizeTitle};
  line-height: 1.75rem;
  margin: 0;
`

export const Description = styled.p.attrs((props) => composeTheme(props))`
  font-family: ${fonts.inter};
  color: ${colors.neutralColorLowDark};
  font-weight: ${(props) => props.theme.collapseCard.fontWeightDescription};
  line-height: 2.1rem;
  font-size: ${(props) => props.theme.collapseCard.fontSizeDescription};
  margin: 1rem 6.4rem 0 0;
`

export const Dropdown = styled.div.attrs((props) => composeTheme(props))`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const Wrap = styled.div`
  display: flex;
  cursor: pointer;
`
